import { track } from '@eventbrite/datalayer-library';
import { Avatar, AvatarSize } from '@eventbrite/eds-avatar';
import { gettext } from '@eventbrite/i18n';
import React, { useEffect } from 'react';
import { LISTING_HEAP_PAGE_AREA_IDS } from '../../../../constants';
import { FollowButton } from '../../FollowButton';
import { useFollowCount } from '../../FollowButton/FollowButton';
import {
    OrganizerStats,
    StyleTypes,
} from '../../OrganizerStats/OrganizerStats';
import { selectedIcon } from '../helperFunctions';
import { OrganiserListingPageProps } from '../OrganiserListingPage/OrganiserListingPage';
import { OrganiserListingPageVariantBProps } from '../OrganiserListingPageVariantB/OrganiserListingPageVariantB';
import './OrganiserListingPageVariantA.scss';

export const OrganiserListingPageVariantA = ({
    organizerName,
    organizerId,
    pageArea,
    style = StyleTypes.CONDENSED_FULL_WIDTH,
    trustSignal,
    signalType,
    organizerAvatar,
}: OrganiserListingPageVariantBProps & OrganiserListingPageProps) => {
    const followersCount = useFollowCount();

    useEffect(() => {
        track({
            eventName: 'ViewTrustSignal',
            eventData: {
                signalType: signalType,
                variantType: 'variant-a',
            },
        });
    }, [signalType]);

    const renderFollowersCount =
        followersCount && followersCount > 9 ? true : false;

    const renderFollowButtonSection = () => (
        <div className="organizer-listing-info-variant-b__follow">
            <FollowButton
                pageArea={
                    pageArea || LISTING_HEAP_PAGE_AREA_IDS.SIMPLIFIED_ORGANIZER
                }
            />
        </div>
    );

    const renderTrustSignal = () =>
        trustSignal && (
            <div className="variant-a-organizer-signal">
                {selectedIcon}
                {trustSignal}
            </div>
        );

    const renderOrganiserStat = () =>
        renderFollowersCount && (
            <div className="variant-a-organizer-follow">
                <OrganizerStats
                    organizer={{ id: organizerId }}
                    followersCount={followersCount || null}
                    style={style}
                    showIcon={true}
                />
            </div>
        );
    return (
        <section
            className="variant-a-organizer-listing-info"
            aria-label="Organizer profile"
        >
            <div className="variant-a-organizer-details">
                <div className="variant-a-organizer-name">
                    {organizerAvatar && (
                        <Avatar
                            size={AvatarSize.xxsmall}
                            imageUrl={organizerAvatar}
                        />
                    )}
                    <div>
                        <strong>
                            {gettext('By')}
                            {` ${organizerName}`}
                        </strong>
                    </div>
                </div>
                {renderOrganiserStat()}
                {renderTrustSignal()}
            </div>
            {renderFollowButtonSection()}
        </section>
    );
};
